<template>
    <div class="projects-wrap">
        <div class="projects-header">
            <h3 class="title-with-dot">{{ headerTitle ? headerTitle : 'Projects'}}</h3>
            <router-link to="/projects" class="theme-btn theme-btn-white">
                View All <i class="las la-arrow-right right-arrow"></i>
            </router-link>
        </div>

        <div class="projects-list">
            <project-item :item="project" v-for="(project, i) in projects" :key="i" />
        </div>
    </div>
</template>

<script>
import ProjectItem from '../modules/ProjectItem.vue';

export default {
    name: 'ProjectSection',
    props: ['headerTitle'],
    components: {
        ProjectItem
    },
    data() {
        return {
            projects: [
                {
                    img: require('@/assets/images/project1.jpg'),
                    title: 'Seven Studio',
                    description: 'Product Design, Logo Design'
                },
                {
                    img: require('@/assets/images/project2.jpg'),
                    title: 'Raven Studio',
                    description: 'Branding, Product Design, Logo Design'
                },
                {
                    img: require('@/assets/images/project3.jpg'),
                    title: 'Dynamic',
                    description: 'Web Designing, Logo Design'
                }
            ]
        }
    }
}
</script>
